// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1b1cf7fa","831":"402f8639"}[chunkId] + ".chunk.js";
};